import { sendErrorAnalytics } from '../../catalog/Analytics';
import { FETCH_ALUMNI_ERROR, FETCH_PLAYERS_ERROR, PLAYER_DOES_NOT_EXIST, FETCH_PLAYER_ERROR } from '../../catalog/NotificationsComments';
import { optimXTesting } from '../../catalog/TeamInfo';
import { isValidString } from '../../catalog/Validity';
import { fetchAlumniFirestoreAPI, fetchPlayersFirestoreAPI, fetchPlayerFirestoreAPI, fetchLimitedAlumniFirestoreAPI, fetchLimitedPlayersFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsPlayer';

export const fetchPlayersAPI = async (teamId: string, alumni: boolean, setState: Function, snackbar: Function) => {
    const players: any = [];
    try {
        let docs;
        if (alumni) {
            docs = await fetchAlumniFirestoreAPI(teamId);
        } else {
            docs = await fetchPlayersFirestoreAPI(teamId);
        }
        docs.forEach((doc) => {
            if (doc.exists) {
                players.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPlayers', players });
    } catch (error) {
        if (alumni) {
            sendErrorAnalytics(FETCH_ALUMNI_ERROR);
        } else {
            sendErrorAnalytics(FETCH_PLAYERS_ERROR);
        }
        if (optimXTesting) {
            if (alumni) {
                snackbar(FETCH_ALUMNI_ERROR, { variant: 'error' });
            } else {
                snackbar(FETCH_PLAYERS_ERROR, { variant: 'error' });
            }
        }
    }
};

export const fetchLimitedPlayersAPI = async (teamId: string, alumni: boolean, count: number, setState: Function, snackbar: Function) => {
    const players: any = [];
    try {
        let docs;
        if (alumni) {
            docs = await fetchLimitedAlumniFirestoreAPI(teamId, count);
        } else {
            docs = await fetchLimitedPlayersFirestoreAPI(teamId, count);
        }
        docs.forEach((doc) => {
            if (doc.exists) {
                players.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPlayers', players });
    } catch (error) {
        if (alumni) {
            sendErrorAnalytics(FETCH_ALUMNI_ERROR);
        } else {
            sendErrorAnalytics(FETCH_PLAYERS_ERROR);
        }
        if (optimXTesting) {
            if (alumni) {
                snackbar(FETCH_ALUMNI_ERROR, { variant: 'error' });
            } else {
                snackbar(FETCH_PLAYERS_ERROR, { variant: 'error' });
            }
        }
    }
};

export const fetchLimitedPlayersForHomepageAPI = async (teamId: string, alumni: boolean, count: number, setState: Function, snackbar: Function) => {
    const players: any = [];
    try {
        let docs;
        if (alumni) {
            docs = await fetchAlumniFirestoreAPI(teamId);
        } else {
            docs = await fetchPlayersFirestoreAPI(teamId);
        }
        docs.forEach((doc) => {
            if (doc.exists) {
                players.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchPlayers', players: players.sort(() => { return 0.5 - Math.random(); }).slice(0, count) });
    } catch (error) {
        if (alumni) {
            sendErrorAnalytics(FETCH_ALUMNI_ERROR);
        } else {
            sendErrorAnalytics(FETCH_PLAYERS_ERROR);
        }
        if (optimXTesting) {
            if (alumni) {
                snackbar(FETCH_ALUMNI_ERROR, { variant: 'error' });
            } else {
                snackbar(FETCH_PLAYERS_ERROR, { variant: 'error' });
            }
        }
    }
};

export const fetchPlayerNameAPI = async (teamId: string, playerId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchPlayerFirestoreAPI(playerId);
        if (doc.exists && doc.data()?.teamId === teamId) {
            if (!doc.data()?.deleted) {
                setState({ type: 'fetchPlayerName',
                    name: doc.data()?.name });
            } else {
                sendErrorAnalytics(PLAYER_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(PLAYER_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(PLAYER_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(PLAYER_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_PLAYER_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_PLAYER_ERROR, { variant: 'error' });
        }
    }
};

export const fetchPlayerAPI = async (teamId: string, playerId: string, setState: Function, snackbar: Function) => {
    try {
        const doc = await fetchPlayerFirestoreAPI(playerId);
        if (doc.exists && doc.data()?.teamId === teamId) {
            if (!doc.data()?.deleted) {
                setState({ type: 'fetchPlayer',
                    name: doc.data()?.name,
                    featureImage: doc.data()?.featureImage,
                    profileImage: doc.data()?.profileImage,
                    details: doc.data()?.details,
                    summary: isValidString(doc.data()?.summary) ? doc.data()?.summary : '',
                    bio: doc.data()?.bio,
                    texts: doc.data()?.texts,
                    alumni: doc.data()?.alumni,
                    deleted: doc.data()?.deleted,
                    overridingStats: doc.data()?.overridingStats });
            } else {
                sendErrorAnalytics(PLAYER_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(PLAYER_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(PLAYER_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(PLAYER_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_PLAYER_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_PLAYER_ERROR, { variant: 'error' });
        }
    }
};
